<template>
	<v-card class="d-flex fill-height opaqueBg" align="center" rounded>
		<v-row justify="center" align="center">
			<v-overlay :value="!Username" opacity-color="white" absolute>
				Select user account
			</v-overlay>
			<v-col cols="11">
				<v-form class="text-center mt-6">
					<v-avatar color="orange" size="60" class="mb-2" outline>
						<v-icon dark>mdi-account-key</v-icon>
					</v-avatar>

					<div class="text-h4 font-weight-light my-4" v-text="Username" />
					<template v-if="Attributes">
						<div class="text-h5 my-2" v-text="Attributes.name" />

						<div>
							<v-chip class="mx-2" v-if="Attributes.email" label color="primary"
								><v-icon left>mdi-email</v-icon> {{ Attributes.email }}</v-chip
							>
						</div>

						<div class="caption mt-4">STATUS</div>
						<div v-text="UserStatus" />

						<div class="caption mt-4">ACCESS GROUPS</div>
						<UserGroups
							:availableGroups="availableGroups"
							:groups="userGroups"
							:isLoading="isLoading"
							@add-to-group="addToGroup"
							@remove-from-group="removeFromGroup"
						/>
					</template>

					<div class="mt-4 mb-2">
						<v-btn color="green" class="mx-2" large dark @click="$emit('edit')">
							<v-icon left>mdi-account-edit</v-icon> Edit
						</v-btn>
						<!--
					<v-btn class="mx-2" color="primary" large @click="resetPassword">
						<v-icon left>mdi-lock-reset</v-icon> Reset Password
					</v-btn> -->

						<v-btn class="mx-2" color="error" large @click="$emit('remove')">
							<v-icon left>mdi-account-minus</v-icon> Delete</v-btn
						>
					</div>
				</v-form>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import UserService from '@/services/UserService'

import UserGroups from '@/components/admin/UserGroups'

export default {
	components: {
		UserGroups,
	},
	data() {
		return {
			userGroups: [],
			availableGroups: [],
			isLoading: false,
		}
	},
	props: {
		Username: String,
		UserStatus: String,
		Enabled: Boolean,
		UserCreateDate: String,
		UserLastModifiedDate: String,
		Attributes: Object,
	},
	async created() {
		this.availableGroups = await UserService.getUserGroups()
	},
	watch: {
		Username: async function (username, oldUsername) {
			if (!username || username == oldUsername) return
			this.isLoading = true
			this.userGroups = await UserService.getGroupsByUser(username)
			this.isLoading = false
		},
	},
	methods: {
		async addToGroup(group) {
			await UserService.addToGroup(this.Username, group)
		},
		async removeFromGroup(group) {
			await UserService.removeFromGroup(this.Username, group)
		},
	},
}
</script>